import { layout } from 'thewest/App.routing'

export const opinionSegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        intermediateColumns: 2,
        finalColumns: 4,
        hideByline: false,
        hasBackground: true,
        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
            ],
        ],
        cardOrientation: { type: 'Landscape-Portrait' },
        sectionHeader: {
            heading: 'Opinion',
            headingUrl: '/opinion',
            section: 'news',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'opinion',
            offset: 0,
            pageSize: 6,
        },
    },
})
